<template>
  <v-btn
    class="TextButton"
    dark
    elevation="0"
    @click="handleClick"
    :color="IconBackgroundColor"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script>
export default {
  name: 'TextButton',
  props: {
    buttonText: {
      type: String,
      default: 'Save'
    },
    IconBackgroundColor: {
      type: String,
      default: 'black'
    },
    copyText: {
      type: String,
      required: true  
    }
  },
  methods: {
    handleClick() {
      navigator.clipboard.writeText(this.copyText)
        .then(() => {
          //console.log('Text copied');
        })
        .catch(error => {
          console.error('error', error);
        });
    }
  }
};
</script>

<style scoped>
.TextButton { background-color: #ffffff; border: 1px solid #bbb; }
</style>
